export default __webpack_public_path__ + "static/media/downButtonHover.7281398a.svg";